import { api } from '@/lib/axios';

export type IncidentType = 'ACCIDENT_TRAVAIL' | 'PRESQUE_ACCIDENT' | 'INCIDENT_ENVIRONNEMENTAL' | 'MALADIE_PRO';
export type Gravite = 'BENIN' | 'GRAVE' | 'FATAL';
export type IncidentStatut = 'OUVERT' | 'EN_COURS' | 'CLOS';
export type EpiStatut = 'EN_SERVICE' | 'A_RENOUVELER' | 'PERIME';

export interface Incident {
  id: string; chantier_id: string | null; employe_concerne_id: string | null; date: string;
  type: IncidentType; gravite: Gravite; description: string | null; jours_arret: number;
  statut: IncidentStatut; actions_correctives: string | null; declaration_cnas_date: string | null;
  chantier_nom: string | null; employe_nom: string | null;
}
export interface IncidentInput {
  chantier_id?: string | null; employe_concerne_id?: string | null; date: string;
  type: IncidentType; gravite: Gravite; description?: string | null; jours_arret?: number;
  statut?: IncidentStatut; actions_correctives?: string | null; declaration_cnas_date?: string | null;
}

export interface Epi {
  id: string; type: string; employe_id: string | null; chantier_id: string | null;
  date_attribution: string | null; date_renouvellement: string | null; statut: EpiStatut;
  notes: string | null; statut_effectif: EpiStatut | null; employe_nom: string | null; chantier_nom: string | null;
}
export interface EpiInput {
  type: string; employe_id?: string | null; chantier_id?: string | null;
  date_attribution?: string | null; date_renouvellement?: string | null; notes?: string | null;
}

export interface TableauBordHSE {
  mois: number; annee: number; incidents_ouverts_mois: number; incidents_total_mois: number;
  jours_arret_mois: number; incidents_graves_fatals_mois: number; epi_a_renouveler_30j: number;
}
export interface StatsHSE {
  heures_travaillees: string; accidents_avec_arret: number; jours_arret: number;
  taux_frequence: number; taux_gravite: number; jours_sans_accident: number | null;
  dernier_accident: string | null;
  evolution: { mois: number; incidents: number; accidents_arret: number; jours_arret: number }[];
}

export async function listIncidents(f?: { chantier_id?: string; type?: IncidentType; gravite?: Gravite; statut?: IncidentStatut; annee?: number; mois?: number }): Promise<Incident[]> {
  const { data } = await api.get<Incident[]>('/hse/incidents', { params: f ?? {} });
  return data;
}
export async function createIncident(payload: IncidentInput): Promise<Incident> {
  const { data } = await api.post<Incident>('/hse/incidents', payload);
  return data;
}
export async function updateIncident(id: string, payload: Partial<IncidentInput>): Promise<Incident> {
  const { data } = await api.put<Incident>(`/hse/incidents/${id}`, payload);
  return data;
}
export async function deleteIncident(id: string): Promise<void> {
  await api.delete(`/hse/incidents/${id}`);
}
export async function listEpi(f?: { employe_id?: string; chantier_id?: string; statut?: EpiStatut }): Promise<Epi[]> {
  const { data } = await api.get<Epi[]>('/hse/epi', { params: f ?? {} });
  return data;
}
export async function createEpi(payload: EpiInput): Promise<Epi> {
  const { data } = await api.post<Epi>('/hse/epi', payload);
  return data;
}
export async function updateEpi(id: string, payload: Partial<EpiInput & { statut: EpiStatut }>): Promise<Epi> {
  const { data } = await api.put<Epi>(`/hse/epi/${id}`, payload);
  return data;
}
export async function deleteEpi(id: string): Promise<void> {
  await api.delete(`/hse/epi/${id}`);
}
export async function getTableauBordHSE(mois: number, annee: number): Promise<TableauBordHSE> {
  const { data } = await api.get<TableauBordHSE>('/hse/tableau-bord', { params: { mois, annee } });
  return data;
}
export async function getStatsHSE(annee: number): Promise<StatsHSE> {
  const { data } = await api.get<StatsHSE>('/hse/statistiques', { params: { annee } });
  return data;
}
